<template>
  <el-dialog title="选择采购退货明细" :visible.sync="visibleInner" width="1000px" append-to-body @close="handleClose">
    <el-form :inline="true" :model="query">
      <el-form-item label="产品编码"><el-input v-model="query.materialCode" size="small" clearable /></el-form-item>
      <el-form-item><el-button size="small" type="primary" @click="search">查询</el-button></el-form-item>
    </el-form>
    <el-table ref="table" :data="list" border v-loading="loading" height="400" row-key="returnLineId" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55" align="center" :reserve-selection="true" />
      <el-table-column prop="materialCode" label="产品编码" width="120" />
      <el-table-column prop="materialName" label="产品名称" min-width="140" />
      <el-table-column prop="specs" label="规格" min-width="100" />
      <el-table-column prop="remainQuantity" label="可出库数量" width="110" align="right" />
    </el-table>
    <div class="selected-tip">已选 {{ selectedCount }} 条</div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="cancel">取消</el-button>
      <el-button type="primary" @click="confirmMultiple">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { docGet } from '../../api/erp/doc'

export default {
  props: {
    visible: { type: Boolean, default: false },
    returnId: { type: String, default: '' },
    excludeStockReturnId: { type: String, default: '' }
  },
  data() {
    return { visibleInner: false, query: { materialCode: '' }, list: [], loading: false, selectedMap: {} }
  },
  computed: {
    selectedCount() { return Object.keys(this.selectedMap).length }
  },
  watch: {
    visible: {
      immediate: true,
      handler(val) {
        this.visibleInner = !!val
        if (val) {
          this.selectedMap = {}
          this.loadList()
        }
      }
    }
  },
  methods: {
    search() { this.loadList() },
    loadList() {
      if (!this.returnId) { this.list = []; return }
      this.loading = true
      docGet('/purchase/purchaseStockReturn/remainLines', {
        returnId: this.returnId,
        materialCode: this.query.materialCode,
        excludeStockReturnId: this.excludeStockReturnId
      }).then(res => { this.list = res.data || [] }).catch(() => {}).finally(() => { this.loading = false })
    },
    handleSelectionChange(rows) {
      const map = {}
      rows.forEach(row => { map[row.returnLineId] = row })
      this.selectedMap = map
    },
    confirmMultiple() {
      const rows = Object.values(this.selectedMap)
      if (!rows.length) { this.$message.warning('请至少选择一条明细'); return }
      this.$emit('select-multiple', rows)
      this.visibleInner = false
      this.$emit('update:visible', false)
    },
    cancel() { this.visibleInner = false; this.$emit('update:visible', false) },
    handleClose() { this.$emit('update:visible', false) }
  }
}
</script>

<style scoped>
.selected-tip { margin: 8px 0; color: #606266; font-size: 13px; }
</style>
